import React from 'react';
import { MemberName as MemberNameBase, MemberNameProps } from '@fx-ui/jdy-design-biz';
import { authModel } from '../../models';
import WWOpenDataCom from '../ww-open-data';
import { MemberStatus, MemberType } from '../../interfaces';
import { platformIntl, TRACKER } from '../../constants';
import MemberCard from '../member-card';
import { Popover } from '@fx-ui/fine-design';
import classNames from 'classnames';
import { tracker } from '../../utils';

interface IMemberNameProps extends MemberNameProps {
    /**
     * 是否显示成员信息卡片
     */
    showViewCard?: boolean;
    /**
     * 触发成员信息卡片方式
     * @default hover
     */
    trigger?: 'hover' | 'click';
    triggerClassName?: string;
    memberId?: string;
}

const MemberName: React.FC<IMemberNameProps> = (props) => {
    const {
        showViewCard,
        memberId,
        trigger = 'hover',
        triggerClassName,
        className,
        ...otherProps
    } = props;
    const { name, status, type, renderName } = otherProps;

    const renderMemberName = (cls?: string) => {
        if (authModel.hasISVEncryptedIntegration && type !== MemberType.external && !renderName) {
            const getSuffix = () => {
                if (status === MemberStatus.dismission) {
                    if (type === MemberType.corp_coop) {
                        return <span>{platformIntl.get('member.removed.suffix')}</span>;
                    } else {
                        return <span>{platformIntl.get('member.resigned.suffix')}</span>;
                    }
                }
            };

            return (
                <MemberNameBase
                    className={cls}
                    {...otherProps}
                    renderName={() => {
                        if (status === MemberStatus.deleted) {
                            return platformIntl.get('member.deleted');
                        }
                        return (
                            <>
                                <WWOpenDataCom openId={name}>{name}</WWOpenDataCom>
                                {getSuffix()}
                            </>
                        );
                    }}
                />
            );
        }

        return <MemberNameBase className={cls} {...otherProps} />;
    };

    if (showViewCard && memberId) {
        return (
            <Popover
                trigger={trigger}
                placement="bottom-left"
                hasPadding={false}
                arrow={false}
                content={<MemberCard memberId={memberId} />}
                onAfterPopupShow={() => {
                    if (trigger === 'click') {
                        tracker(TRACKER.MEMBER_CARD_SETTINGS_CLICK);
                    } else {
                        tracker(TRACKER.MEMBER_CARD_SETTINGS_HOVER);
                    }
                }}
            >
                <span
                    className={triggerClassName}
                    style={{
                        display: 'inline',
                        cursor: 'pointer'
                    }}
                >
                    {renderMemberName(className)}
                </span>
            </Popover>
        );
    }

    return renderMemberName(classNames(triggerClassName, className));
};

export default MemberName;
